import { useState, useEffect } from 'react';

// True only on real mobile devices (mobile UA or touch-only) narrower than 768px
export function useMobileDetection(): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => {
      const ua = navigator.userAgent;
      const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
      const narrowScreen = window.innerWidth < 768;
      const touchOnly = window.matchMedia('(pointer: coarse)').matches &&
                        !window.matchMedia('(pointer: fine)').matches;
      setIsMobile((mobileUA || touchOnly) && narrowScreen);
    };

    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return isMobile;
}
